import { render, staticRenderFns } from "./FormUploadFiles.vue?vue&type=template&id=348c44cf&scoped=true&"
import script from "./FormUploadFiles.vue?vue&type=script&lang=js&"
export * from "./FormUploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./FormUploadFiles.vue?vue&type=style&index=0&id=348c44cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c44cf",
  null
  
)

export default component.exports